export default __webpack_public_path__ + "static/media/map.a593509b.png";